import React, { useState } from "react";
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FaStar, FaRegStar } from 'react-icons/fa';
import { PiUsers } from "react-icons/pi";
import { CiLocationOn } from "react-icons/ci";
import { MdOutlineAccessTime } from "react-icons/md";
import { useNavigate, NavLink, Link } from 'react-router-dom';
import { TbMoneybag } from "react-icons/tb";
import SignupPage from '../Signup/SignupPage';
import { Button, Container, Col, Form, Row, Modal } from 'react-bootstrap';
import Footer from '../Footer/Footer';



const ServicesList = [
  {
    id: 1,
    name: 'Veritis Development Agency',
    image: 'https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 4.5,
    review: 26,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },

  {
    id: 2,
    name: 'Aevitas Development Agency',
    image: 'https://img.freepik.com/free-vector/colorful-letter-gradient-logo-design_474888-2309.jpg',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 4.9,
    review: 262,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },

  {
    id: 3,
    name: 'Oractel Data Solutions',
    image: 'https://cryptologos.cc/logos/arbitrum-arb-logo.png',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 4.2,
    review: 32,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },

  {
    id: 4,
    name: 'ITR Mobile Solutions',
    image: 'https://www.logoai.com/oss/icons/2021/10/27/MuCSnBxFpOQg2Kl.png',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 3.9,
    review: 125,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },

  {
    id: 5,
    name: 'Gtech Corporation',
    image: 'https://www.logoai.com/oss/icons/2021/10/27/VgRTHEL8YOYKnCn.png',
    staff: '10 - 49',
    location: 'New York, USA',
    budget: '$25,000+',
    hourrate: '$50 - $99/hr',
    rating: 4.1,
    review: 200,
    description: 'Veritis is a global Information Technology (IT) consulting services provider focused on delivering high value to clients through integrated, reliable and cost-effective solutions. The major service lines that we focus on are Cloud, Containerization, DevOps, Digital Transformation, Managed IT Services, and Technology Advisory Services. We at Veritis gauge our success by our customers’ success. We regard it as a privilege to serve our customers and are committed to doing whatever it takes to ensure they are 100 percent satisfied.',
    services: ['Website Development', 'App Development', 'Development', 'AWS', 'Azure', 'Design']
  },
];




function ServiceListBeforeLoginComponent() {
  const navigate = useNavigate();
  const [bookmarked, setBookmarked] = useState(false);
  const [filters, setFilters] = useState({
    location: '',
    service: '',
    hourlyRate: '',
    employees: '',
    reviews: ''
  });



  // const handleProfileClick = (id) => {
  //   navigate(`/profile/${id}`);
  // };

  // onClick={() => handleProfileClick(profile.id)}


  const toggleBookmark = () => {
    setBookmarked(!bookmarked);
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };



  const [showSignup, setShowSignup] = useState(false);

  const handleShowSignup = () => setShowSignup(true);
  const handleCloseSignup = () => setShowSignup(false);


  const vendors = [
    { name: 'Google', logo: 'https://www.svgrepo.com/show/303108/google-icon-logo.svg', rating: 4.5, reviews: 125 },
    { name: 'Yelp', logo: 'https://cdn.worldvectorlogo.com/logos/yelp-1.svg', rating: 4.2, reviews: 98 },
    { name: 'Trustpilot', logo: 'https://cdn.worldvectorlogo.com/logos/trustpilot-2.svg', rating: 4.7, reviews: 200 },
    { name: 'Glassdoor', logo: 'https://cdn.worldvectorlogo.com/logos/glassdoor-1.svg', rating: 4.0, reviews: 85 },
    { name: 'Facebook', logo: 'https://cdn.worldvectorlogo.com/logos/facebook-2020-2-1.svg', rating: 4.3, reviews: 150 }
  ];


  const popover = (
    <Popover id="popover-basic" style={{ maxWidth: '300px', width: '300px' }}>
   <Popover.Header as="h3">Vendor Reviews</Popover.Header>
    <Popover.Body className="m-0 p-0">
      {vendors.map((vendor, index) => (
        <div key={index} className="d-flex p-2 px-3 align-items-center border-bottom">
          <img src={vendor.logo} alt={vendor.name} className="me-3 border rounded p-1" width="30" height="30" />
          <div>
            <p className="mb-0 fw-500 pb-1">{vendor.name}</p>
            <span className="card-text rating">
              <span className="me-2 fw-600">{vendor.rating.toFixed(1)}</span>
              {[...Array(5)].map((_, i) =>
                i < Math.round(vendor.rating) ? (
                  <FaStar key={i} className="text-warning" />
                ) : (
                  <FaRegStar key={i} className="text-warning" />
                )
              )}
              <span className="ms-2 small">({vendor.reviews} Reviews)</span>
            </span>
          </div>
        </div>
      ))}
    </Popover.Body>
    </Popover>
  );


  return (
    <>

<div className="sub-header sub-search py-3 bg-light border-bottom border-top">
      <Container>
        <Row className="align-items-start">
          <Col md={12}>
            <Form className="d-flex">
              <Form.Control
                type="search"
                placeholder="e.g. App Development, UX Design, IT Services..."
                className="me-4 px-4 rounded-5"
                aria-label="Search"
              />
              <Form.Control
                type="text"
                placeholder="Enter location"
                className="me-4 px-4 rounded-5"
                aria-label="Location"
              />
              <Button variant="primary" className="px-4 rounded-5">Search</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>


    <section className="page-header bg-skyblue py-2">
    <div className="container py-4 pb-2">
          <div className="row page-introduction">
          <div className="col-12">
            <div className="d-flex align-items-start justify-content-between">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item small"><a href="#">Home</a></li>
                  <li class="breadcrumb-item small active" aria-current="page">Web Design</li>
                </ol>
              </nav>
              <span><strong>18530</strong> Companies Listed</span>
            </div>

            <h3 className="mt-2">Top Website Development Companies</h3>
            <p className="mini-content text-muted">We have created a global list of top mobile app development companies to help you hire the best app developers.</p>
          </div>
        </div>
        </div>
      </section>


      <div className="container mt-4 mb-4">
      <div className="row">
      <div className="col-12">
        <div className='card rounded-4 p-2 bg-white shadow-sm'>
          <div className='card-body'>


            <div className="d-flex flex-wrap gap-4">


        <select name="service" className="form-select w-auto pe-5" onChange={handleFilterChange}>
          <option value="">Services</option>
          <option value="Website Development">Website Development</option>
          <option value="App Development">App Development</option>
          <option value="AWS">AWS</option>
        </select>


        <select name="reviews" className="form-select w-auto pe-5" onChange={handleFilterChange}>
          <option value="">Reviews</option>
          <option value="4+">4+ Stars</option>
          <option value="3+">3+ Stars</option>
          <option value="2+">2+ Stars</option>
          <option value="1+">1+ Stars</option>
        </select>

        <select name="hourlyRate" className="form-select w-auto pe-5" onChange={handleFilterChange}>
          <option value="">Hourly Rate</option>
          <option value="0-25">$0 - $25/hr</option>
          <option value="25-50">$25 - $50/hr</option>
          <option value="50-100">$50 - $100/hr</option>
          <option value="100+">$100+/hr</option>
        </select>
        </div>
            </div>
            </div>
          </div>
        </div>

        <div className="py-4 mt-4 d-flex justify-content-between align-items-center">
          <h5>Here are the 214 Best Web Development Companies</h5>

          <div className="d-flex align-items-center">
            <label className="me-2 fw-regular text-muted">Sort By:</label>
            <select className="form-select w-auto pe-5">
              <option value="sponsored">Sponsored</option>
              <option value="high-rating">High Rating</option>
            </select>
          </div>
        </div>


      <div className="row">
      {ServicesList.map(profile => (
  <div className='col-12 mb-4'key={profile.id}>
              <div className="d-lg-flex card rounded-4 align-items-stretch p-4">
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between'>
              <div className='d-flex align-items-center'>
                    <img src={profile.image} className="img-thumbnail rounded-3 border-1 me-3" alt={profile.name} style={{ maxWidth: '80px' }} />
                    <div>
                        <h5 className="card-title">
                         <NavLink as={Link} to="/CompnayProfileDetailed" className='p-0 m-0 text-decoration-none text-dark'>{profile.name}</NavLink>                            <span className="ms-3 small verify py-1 rounded-4 fs-6 p-2 text-success"><i class='bx text-success bxs-check-circle' ></i> Verified</span>
                        </h5>
                          <span className="card-text rating">
                          <strong className="me-2"> {profile.rating}</strong>
                            {[...Array(5)].map((_, index) =>
                              index < profile.rating ? (
                                <FaStar key={index} className="text-warning" />
                              ) : (
                                <FaRegStar key={index} className="text-warning" />
                              )
                            )}
                            <span className="ms-2 small">(26 Reviews)</span>



                          </span>
                    </div>
                  </div>

                       <div>

                            <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
                          <button className="me-3 border btn btn-sm small">
                            Vendor Reviews <FaStar className="text-warning" />
                          </button>
                        </OverlayTrigger>

                         <button className='btn fs-2 p-0 m-0 pt-2 me-3 icon-clr' onClick={toggleBookmark}>
                         <i class='bx bx-bookmark' ></i>     </button>
                         <button className='btn fs-2 p-0 m-0 pt-2 me-3 icon-clr' onClick={toggleBookmark}>
                   <i class='bx bxs-check-shield' ></i>
                 </button>
                 <Button className="btn btn-primary me-2" onClick={handleShowSignup}>Hire Us</Button>
                       </div>
                  </div>

                  <p className="py-3 text-muted">{profile.description}</p>


                    <div className='d-flex justify-content-between align-items-center border-top pt-3'>
                      <div className="d-flex">
                      <p className="fw-500 mt-3 me-4">
                        <TbMoneybag className="me-2 text-primary fs-5" /> {profile.budget}
                      </p>
                      <p className="fw-500 mt-3 me-4">
                        <MdOutlineAccessTime className="me-2 text-primary fs-5" /> {profile.hourrate}
                      </p>
                      <p className="fw-500 mt-3 me-4">
                        <PiUsers className="me-2 text-primary fs-5" /> {profile.staff}
                      </p>
                      <p className="fw-500 mt-3">
                        <CiLocationOn className="me-2 text-primary fs-5" /> {profile.location}
                      </p>
                    </div>

                    <div className="mt-1">
                  {/* <button className='btn btn-outline-primary text-primary me-2'>I'm Interested</button> */}
                  <NavLink to="/CompnayProfileDetailed" className="btn btn-outline-primary text-primary me-3">View Profile</NavLink>
                  <button className='btn btn-outline-primary text-primary'>Visit Website</button>
                </div>
                </div>
                </div>
              </div>
            </div>
        ))}


<div className="d-flex justify-content-between align-items-center p-3 mb-5">
  <div className="text-muted">Showing 10 of 215</div>
  <nav aria-label="Page navigation">
    <ul className="pagination mb-0">
      <li className="page-item disabled">
        <button className="page-link">Previous</button>
      </li>
      <li className="page-item active">
        <button className="page-link">1</button>
      </li>
      <li className="page-item">
        <button className="page-link">2</button>
      </li>
      <li className="page-item">
        <button className="page-link">3</button>
      </li>
      <li className="page-item">
        <button className="page-link">Next</button>
      </li>
    </ul>
  </nav>
</div>

      </div>

    </div>


       <Modal show={showSignup} onHide={handleCloseSignup} centered>
        <Modal.Header closeButton>
          <Modal.Title>Sign Up</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <SignupPage onSignup={(data) => console.log(data)} buttonText="Continue" redirectTo="/ServicesList" />
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
}

export default ServiceListBeforeLoginComponent;